import React from "react";

export enum PricingCards {
  START = "start",
  PRO = "pro",
  ENTERPRISE = "enterprise",
}

export type UpcomingItem = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
};

export type FutureItem = {
  title: string;
  description?: string;
};

export type PricingCardType = {
  plan: string;
  badge?: string; // Optional
  title: string;
  subtitle: string;
  price: string;
  features: FutureItem[];
  ctaLabel: string;
  ctaAction: () => void;
  footerNote: string;
  upcomingTitle?: string; // Optional
  upcomingSubtitle?: string; // Optional
  upcomingItems?: UpcomingItem[]; // Optional
};
